import React from 'react';
import { Breadcrumb } from 'antd';
import type { BreadcrumbProps as AntBreadcrumbProps } from 'antd';
import type { BaseComponentProps } from '../../types/common';

export interface AndBreadCrumbProps extends AntBreadcrumbProps, BaseComponentProps {}

export const AndBreadCrumb: React.FC<AndBreadCrumbProps> = ({
  id, sessionId, develop, items, children, ...restProps
}) => {
  return <Breadcrumb {...restProps} items={items}>{children}</Breadcrumb>;
};

export default AndBreadCrumb;
